// use field constants to ensure consistency in form validation handling (both for yup schema and server errors)

export default {
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  NAME: 'name',
  // We alias BIRTH_DATE for BIRTH_DATE_YEAR for convenience in mapping server errors to the UI.
  // We need to pick one field since there are 3 and year is the most significant of the 3.
  BIRTH_DATE: 'birthDateYear',
  BIRTH_DATE_YEAR: 'birthDateYear',
  BIRTH_DATE_MONTH: 'birthDateMonth',
  BIRTH_DATE_DAY: 'birthDateDay',
  LOCATION: 'location',
  USERNAME: 'username',
  NEW_PASSWORD: 'newPassword',
  // #region recovery
  RECOVERY_OPTION: 'recoveryOption',
  TEXT: 'smsNumber',
  TEXT_LOCATION: 'smsNumberLocation',
  EMAIL: 'email',
  WHATS_APP: 'whatsAppNumber',
  WHATS_APP_LOCATION: 'whatsAppNumberLocation',
  VERIFICATION_CODE: 'code',
  // #endregion
  ACCEPT_TERMS: 'acceptTerms',
  CITIZEN: 'citizen',
  // #region marketing messages
  RECEIVE_EMAIL_MESSAGES: 'receiveEmailMessages',
  RECEIVE_TEXT_MESSAGES: 'receiveSmsMessages',
  MESSAGES_OPTION: 'messagesOption',
  MESSAGES_TEXT: 'messagesSmsNumber',
  MESSAGES_TEXT_LOCATION: 'messagesSmsNumberLocation',
  MESSAGES_EMAIL: 'messagesEmail',
  MESSAGES_WHATS_APP: 'messagesWhatsAppNumber',
  MESSAGES_WHATS_APP_LOCATION: 'messagesWhatsAppNumberLocation',
  // #endregion
  ADD_CHURCH_MEMBERSHIP: 'addChurchMembership',
  RECORD_NUMBER: 'recordNumber',
  // #region parental consent
  CONSENT_OPTION: 'consentOption',
  CONSENT_TEXT: 'consentSmsNumber',
  CONSENT_VERIFICATION_CODE: 'consentCode',
  CONSENT_TEXT_LOCATION: 'consentSmsNumberLocation',
  CONSENT_EMAIL: 'consentEmail',
  CONSENT_WHATS_APP: 'consentWhatsAppNumber',
  CONSENT_WHATS_APP_LOCATION: 'consentWhatsAppNumberLocation',
  CONSENT_RECORD_NUMBER: 'consentRecordNumber',
  // #endregion
  // #region login
  PRIVATE_COMPUTER: 'privateComputer',
  CURRENT_PASSWORD: 'currentPassword',
  // #endregion
  // special field name used to coordinate replaying submission
  // if consent page returns to first page to handle edge case errors
  // (rare cases such as if username was taken after it first passed validation)
  RETRY_SUBMIT: 'retrySubmit',
  // special field name used to inform parental consent to call temple experience backend
  IS_TEMPLE_EXPERIENCE: 'isTempleExperience',
}
